export default {"src":"https://static.jusbr.com/web/docview/_next/static/media/validation.fd3048b2.svg","height":140,"width":141,"blurWidth":0,"blurHeight":0};